import { render, staticRenderFns } from "./UserAccessList.vue?vue&type=template&id=88a5546a&"
import script from "./UserAccessList.vue?vue&type=script&lang=js&"
export * from "./UserAccessList.vue?vue&type=script&lang=js&"
import style0 from "./UserAccessList.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports